import { type ProgramUserRemoveInput, type ProgramUserRemoveSuccess, toResponseError } from '@terros/common'
import { mutationRemove, type RemoveHookResponse } from '../hooks'
import { useTantalimMutation } from '../mutation'
import { useProgramCache } from './cache'

export function useRemoveProgramUsers(): RemoveHookResponse<ProgramUserRemoveInput> {
  const mutation = useTantalimMutation<ProgramUserRemoveInput, ProgramUserRemoveSuccess>({
    url: '/program/user/remove',
  })
  const cache = useProgramCache()

  async function remove(input: ProgramUserRemoveInput): Promise<void> {
    try {
      await mutation.mutateAsync(input)
      cache.clearUsers(input.programId)
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationRemove(mutation, remove)
}
